import { PvsCampaign, P3Campaign } from 'models/interfaces';

function validateStartDate(value: string, values: any) {
  // console.log('validateStartDate fired!');
  const startDate = new Date(value);
  const endDate = new Date(values.endDate);

  // console.log('Start Date:', startDate);
  // console.log('End Date:', endDate);

  if (!value) {
    return 'Campaign Start Date is required';
  }

  if (endDate && startDate > endDate) {
    return 'Campaign Start Date must be before Campaign End Date';
  }

  return null;
}

function validateEndDate(value: string, values: any) {
  // console.log('validateEndDate fired!');
  const endDate = new Date(value);
  const startDate = new Date(values.startDate);

  // console.log('Start Date:', startDate);
  // console.log('End Date:', endDate);

  if (!value) {
    return 'Campaign End Date is required';
  }

  if (endDate && startDate > endDate) {
    return 'Campaign End Date must be after Campaign Start Date';
  }

  return null;
}

function defaultValidator() {
  return true;
}

function pvsCampaignValidator(campaignModule: PvsCampaign) {
  if (!campaignModule.vertical_id) {
    return false;
  }

  return true;
}

function p3CampaignValidator(campaignModule: P3Campaign) {
  console.log('p3CampaignValidator: ', campaignModule);

  if (!campaignModule.name) {
    return false;
  }

  if (!campaignModule.entitled_rank_points) {
    return false;
  }

  return true;
}

function getCampaignModuleValidator(productId: number) {
  switch (productId) {
    case 1:
      return pvsCampaignValidator;
    case 2:
      return p3CampaignValidator;
    default:
      return defaultValidator;
  }

  return () => true;
}

function validateCampaignModule(productId: number, campaignModule: any) {
  const validator = getCampaignModuleValidator(productId);

  if (typeof validator !== 'function') {
    return true;
  }

  return validator(campaignModule);
}

export { validateStartDate, validateEndDate, validateCampaignModule };
